import { buildInternalUrl } from "./tracking-url";

/**
 * "signup" sends every CTA to the app's start page; "demo" (`/vorsprung-demo`)
 * sends every CTA to the booking page instead and never links to signup;
 * "form" (`/anfrage`) scrolls every CTA to the inline lead-form section on the
 * same page instead of navigating away.
 */
export type VorsprungVariant = "signup" | "demo" | "form";

/** A resolved CTA destination: href for real navigation, onClick for tracking. */
export type Cta = {
  href: string;
  onClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
};

/**
 * Booking-page link, carrying the ad's utm and click IDs the same way the
 * cross-domain app hop does. Computed per render (not module scope) so params
 * restored after the 404-redirect or captured later are always picked up.
 */
export const demoUrl = () => buildInternalUrl("/demo");

export const ctaSource = (variant: VorsprungVariant) =>
  variant === "demo" ? "vorsprung-demo" : variant === "form" ? "anfrage" : "vorsprung";

/** Shared by /demo's navbar CTA and its mobile scroll button. */
export const scrollToBooking = () =>
  document
    .getElementById("booking")
    ?.scrollIntoView({ behavior: "smooth", block: "start" });

/** Shared by /anfrage's navbar CTA and every in-page CTA in "form" variant. */
export const scrollToForm = () =>
  document
    .getElementById("anfrage-form")
    ?.scrollIntoView({ behavior: "smooth", block: "start" });
